export const INITIAL_PASSWORD = 'hs123456';

export const INITIAL_PASSWORD_RESET_MESSAGE = `密码已重置为 ${INITIAL_PASSWORD}`;
